import { computed, watch } from 'vue';
import { RouteLocationNormalized } from 'vue-router';
import { addonStateLoaded, hasAddon } from '~/plugins/addon';

class Addon implements Middleware {
    name() {
        return 'addon';
    }

    async run(to: RouteLocationNormalized): Promise<
        | void
        | boolean
        | {
              name: string;
              replace?: boolean;
              params?: any;
              query?: any;
              hash?: any;
          }
    > {
        if (to.meta?.addon) {
            const addon = to.meta.addon as string;
            const result = computed(() => hasAddon(addon));

            if (!addonStateLoaded(addon)) {
                return new Promise((resolve) => {
                    const unregister = watch(result, () => {
                        unregister();

                        if (!result.value) {
                            resolve({
                                name: '404',
                                params: {
                                    catchAll: location.pathname.substring(1).split('/'),
                                },
                                query: to.query,
                                hash: to.hash,
                            });
                        } else {
                            resolve(undefined);
                        }
                    });
                });
            } else if (!result.value) {
                return {
                    name: '404',
                    params: {
                        catchAll: location.pathname.substring(1).split('/'),
                    },
                    query: to.query,
                    hash: to.hash,
                };
            }
        }
    }
}

export default new Addon();
